import { v4 as uuidv4 } from 'uuid';
import { useUIInteractionEvents } from '@ilteducation/activity-stream-events';

const partitionKey = uuidv4();

const { uiInteractionEvent } = useUIInteractionEvents({ partitionKey, sourceApplication: 'manabua' });

export const useActivityStream = () => {
  const logCreateCollection = (view: string) => uiInteractionEvent('CreateContentCollection', { view });
  const logAddContentToCollection = (view: string) => {
    return uiInteractionEvent('AddContentToCollection', { view });
  };
  const logDeleteCollection = (view: string) => uiInteractionEvent('DeleteContentCollection', { view });

  return {
    logCreateCollection,
    logAddContentToCollection,
    logDeleteCollection,
  };
};
